module.exports = __webpack_public_path__ + "static/media/logo-gouvernement.6eb608a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo-gouvernement.png
// module id = 1673
// module chunks = 0